import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import FdwEmployerForm from "./formEmployer/FdwEmployerForm";
import Lang from "../common/Lang";

const CollectEmployerInfo = () => {
  const { t } = useTranslation();

  return (
    <div className="min-vh-100" style={{ backgroundColor: "#f8f9fa" }}>
      {/* Top Navigation Header */}
      <nav className="navbar navbar-expand-lg navbar-dark shadow-sm" style={{ backgroundColor: "#2e5aa9" }}>
        <div className="d-flex px-4">
          {/* Logo */}
          <div className="navbar-brand d-flex align-items-center">
            <img 
              src="/logo.png" 
              alt="Company Logo" 
              height="40"
              style={{ filter: "brightness(0) invert(1)" , maxWidth:"30%",marginLeft:"10px"}}
              className="me-2"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'inline';
              }}
            />
          
          </div>

          {/* Language Selector */}
          <div className="d-flex align-items-center">
            <Lang className="collectInfo-lang" />
          </div>
        </div>
      </nav>

      {/* Hero Section */}
      <div style={{ backgroundColor: "#2e5aa9" }} className="text-white py-4 border-top border-light border-opacity-25">
        <div className="container-fluid px-4">
          <div className="row justify-content-center">
            <div className="col-12 text-center">
              <div className="d-flex align-items-center justify-content-center mb-3">
                <i className="fa-solid fa-clipboard-list fa-2x me-3"></i>
                <h1 className="mb-0 fw-bold text-white">{t("Employer Information Collection")}</h1>
              </div>
              <p className="lead mb-0 opacity-90">
                {t("Please provide your information to help us serve you better")}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="container-fluid py-5 px-4">
        <div className="row justify-content-center">
          <div className="col-12" style={{ maxWidth: '90%' }}>
            {/* Welcome Card */}
            <div className="card shadow-sm border-0 mb-4">
              <div className="card-body p-4">
                <div className="d-flex align-items-center mb-3">
                  <div className="bg-light rounded-circle p-2 me-3">
                    <i className="fa-solid fa-info-circle text-primary"></i>
                  </div>
                  <h5 className="card-title mb-0 text-primary">{t("Welcome!")}</h5>
                </div>
                <p className="card-text text-muted mb-0">
                  {t("Thank you for taking the time to complete this form. Your information will help us provide you with the best possible service. All information provided will be kept confidential and secure.")}
                </p>
              </div>
            </div>

            {/* Form Card */}
            <div className="card shadow-sm border-0">
              <div className="card-header bg-white border-bottom py-3">
                <div className="d-flex align-items-center justify-content-between">
                  <div className="d-flex align-items-center">
                    <i className="fa-solid fa-user-edit text-primary me-2"></i>
                    <h5 className="mb-0">{t("Employer Details")}</h5>
                  </div>
                  <div className="text-muted small">
                    <i className="fa-solid fa-shield-alt text-success me-1"></i>
                    {t("Secure Form")}
                  </div>
                </div>
              </div>
              <div className="card-body p-4">
                <FdwEmployerForm />
              </div>
            </div>

            {/* Security Notice */}
            <div className="mt-4">
              <div className="alert alert-light border d-flex align-items-center" role="alert">
                <i className="fa-solid fa-shield-alt text-success me-3"></i>
                <div>
                  <small className="fw-semibold text-success">{t("Secure & Confidential")}</small>
                  <br />
                  <small className="text-muted">
                    {t("Your information is protected with industry-standard encryption and will never be shared with third parties without your consent.")}
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer 
      <footer className="bg-dark text-white py-3 mt-auto">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <small>&copy; 2025 {t("Kflow")}. {t("All rights reserved")}.</small>
            </div>
            <div className="col-md-6 text-md-end">
              <small>
                <a href="#" className="text-white-50 text-decoration-none me-3">
                  <i className="fa-solid fa-phone me-1"></i> {t("Contact Support")}
                </a>
                <a href="#" className="text-white-50 text-decoration-none">
                  <i className="fa-solid fa-question-circle me-1"></i> {t("Help")}
                </a>
              </small>
            </div>
          </div>
        </div>
      </footer>*/}
    </div>
  );
};

export default CollectEmployerInfo;